import React from 'react'
import './Contact.css'
import {MdOutlineEmail} from 'react-icons/md'
import {BsWhatsapp} from 'react-icons/bs'
import { useRef } from 'react';
import emailjs from '@emailjs/browser';


const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_g411w2f', 'template_x890xdh', form.current, 'Pv8_9rbzkLlHxAJgT')
    e.target.reset()
  };

  return (
    <section id="Contact">
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>
      <div className="container contact__container">
        <div className="contact__options">
          <article className="contact__option">
            <MdOutlineEmail className="contact__option-icon"/>
            <h4>Email</h4>
            <h5>nanorgosdanian@gmail.com</h5>
            <a href="mailto:nanorgosdanian@gmail.com"> Send a Message</a>
          </article>

          <article className="contact__option">
            <BsWhatsapp className="contact__option-icon"/>
            <h4>WhatsApp</h4>
            <h5>+96176633014</h5>
            <a href="https://api.whatsapp.com/send?phone=096176633014"> Send a Message</a>
          </article>

          
        </div>
        <form ref={form} onSubmit={sendEmail}>
          <input type="text" name="name" placeholder="Your Full Name" required />
          <input type="email" name="email" placeholder="Your Email" required />
          <textarea name="message" rows="7"  placeholder="Your Message" required></textarea>
          <button type="submit"  onSubmit={sendEmail} className="btn btn-primary"> Send Message</button>
        </form>
      </div>

    </section>
  )
}

export default Contact